import store from '../store'
import axios from 'axios'

export default function logout ({ from, to, next }) {
  var keyApp = localStorage.getItem('APP_KEY')
  var keyAppItems = localStorage.getItem('APP_KEY_ITEMS')
  localStorage.clear()
  delete axios.defaults.headers.common.Authorization
  store.commit('CLEAR_COMPONENTS', [])
  localStorage.setItem('APP_KEY', keyApp)
  if (keyAppItems != null) {
    localStorage.setItem('APP_KEY_ITEMS', keyAppItems)
  }
  if (store.state.application) {
    this.$router.push({ name: 'mlogin' })
  } else {
    return next()
  }
}
